import bookingForm from '../modules/booking/booking-form';
import formTracker from '../modules/utility/form-event-tracker';

if (bookingForm.canInit('#booking-form')) {
    bookingForm.init();
}

if (formTracker.canInit('#booking-form')) {
    formTracker.init();
}

document.addEventListener('DOMContentLoaded', function () {
    const dateInput = document.getElementById('preferredDate');
    if (dateInput) {
        flatpickr(dateInput, {
            altInput: true,
            altFormat: "d/m/Y",
            dateFormat: "Y-m-d",
            minDate: "today",
            "locale": {
                "firstDayOfWeek": 1
            },
            disable: [
                function (date) {
                    return date.getDay() === 0 || date.getDay() === 6;   // disable weekends
                }
            ]
        });
    }
});